import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sm:text-2xl text-xl text-pada font-bold" }
const _hoisted_2 = { class: "mt-4 text-def sm:text-3xl text-2xl leading-relaxed font-bold sm:leading-relaxed" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col", _ctx.align])
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.content1) + " ", 1),
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.content2), 1)
    ])
  ], 2))
}